import {registerPlugin} from '@capacitor/core';

export type NativeMediaPublishState = 'queued' | 'uploading' | 'uploaded' | 'failed';

export interface NativeMediaPublishInput {
  /** Assigned by JavaScript before enqueueing so retained native events can
   * always be correlated, even if an upload finishes immediately. */
  clientJobId: string;
  mediaPath: string;
  thumbnailPath?: string | null;
  mediaType: 'image' | 'video';
  mimeType: string;
  thumbnailTime?: number | null;
  filterPreset?: string | null;
  apiUrl: string;
}

export interface NativeMediaPublishJob {
  jobId: string;
}

export interface NativeMediaPublishEvent {
  jobId: string;
  state: NativeMediaPublishState;
  progress?: number;
  mediaIri?: string;
  errorCode?: string;
}

export interface NativeMediaPublisherPlugin {
  enqueue(options: NativeMediaPublishInput): Promise<NativeMediaPublishJob>;
  resumePending(): Promise<void>;
  cancel(options: {jobId: string}): Promise<void>;
  retry(options: {jobId: string}): Promise<void>;
  addListener(eventName: 'jobState', listenerFunc: (event: NativeMediaPublishEvent) => void): Promise<{remove: () => Promise<void>}>;
}

export const NativeMediaPublisher = registerPlugin<NativeMediaPublisherPlugin>('NativeMediaPublisher');
